// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { useHistory, useLocation } from 'react-router-dom'
// import css from '../css/Addcase.module.css'
// import { Link } from 'react-router-dom'
// import Header from '../Components/Header'
// import Rightcontainer from '../Components/Rightcontainer'
// import Swal from 'sweetalert2'
// import socket from '../Components/socket'
// import { useTheme } from '../../ThemeContext'
// import { apiRequest } from '../../apiService/allApi'

// const Redeem = ({ walletUpdate }) => {
//   const history = useHistory()

//   // BASE URL

//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const nodeMode = process.env.NODE_ENV;
//   if (nodeMode === "development") {

//     var baseUrl = beckendLocalApiUrl;
//   } else {
//     baseUrl = beckendLiveApiUrl;
//   }
//   // +++++++++++++++++++++++++++++ 

//   const [amount, setamount] = useState()
//   const [userAllData, setUserAllData] = useState()
//   const role = async () => {
//     socket.emit('getprofile')

//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     const res = await apiRequest(`me`, "GET", null, headers)

//     setUserAllData(res.data)

//   }

//   useEffect(() => {
//     let access_token = localStorage.getItem('token')
//     access_token = localStorage.getItem('token')
//     if (!access_token) {
//       window.location.reload()
//       history.push('/login')
//     }
//     role()
//   }, [])

//   const deposit = async () => {
//     if (amount && amount >= 95 && amount <= 100000) {
//       const access_token = localStorage.getItem('token')
//       const headers = {
//         Authorization: `Bearer ${access_token}`
//       }


//       const res = await apiRequest(`referral/to/wallet`, "POST", { amount }, headers)


//       if (res.data.msg === 'Invalid Amount') {
//         Swal.fire({
//           title: "You don't have sufficient amount",
//           icon: 'warning',
//           confirmButtonText: 'OK'
//         })
//       } else {
//         Swal.fire({
//           title: 'success',
//           icon: 'success',
//           confirmButtonText: 'OK'
//         })
//       }
//     } else {
//       let msg = 'Enter Amount'
//       if (!amount) {
//         msg = 'Enter Amount'
//       } else if (95 <= amount <= 100000) {
//         msg = 'Amount should be more than 100.'
//       }
//       Swal.fire({
//         title: msg,
//         icon: 'Error',
//         confirmButtonText: 'OK'
//       })
//     }
//   }

//   // change theme 
//   const theme = localStorage.getItem('theme')
//   const styles = {
//     backgroundColor: theme === 'light' ? '#fff' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };

//   return (
//     <>
//       <Header user={userAllData} />
//       <div className=" leftContainer redeemPro">

//         {/* TOP HEADER SECTION */}
//         <div className="redeemHeader">
//           {/* <img src="/images/purse.png"  className="headerIcon" /> */}
//           <div>
//             <h2>Redeem Referral Balance</h2>
//             <p>Convert referral balance to MKADDA Coins</p>
//           </div>
//         </div>

//         {/* MAIN AMOUNT BOX */}
//         <div className="amountHighlight">
//           <img src="/images/purse.png" />

//           {/* IMPORTANT CONTENT INSERTED HERE */}
//           <h3>TDS (0%) will be deducted after earning of ₹15,000</h3>
//           <p className="sub">Minimum withdrawal amount ₹100</p>
//         </div>

//         {/* STATIC BOX */}
//         <div className="badgeItemSolo">
//           <img src="/refer-box.png" />
//           Money will be added to MKADDA Coin.
//         </div>

//         {/* INPUT LABEL */}
//         <div className="amountLabel">
//           Enter Amount <span>(Min: 100, Max: 10000)</span>
//         </div>

//         {/* INPUT */}
//         <input
//           type="number"
//           value={amount}
//           placeholder="Enter Amount"
//           className="redeemInputFinal"
//           onChange={(e) => setamount(parseInt(e.target.value))}
//         />

//         {/* BUTTON */}
//         <button className="btnRedeemFinal mt-3" onClick={() => deposit()}>
//           Redeem Now
//         </button>

//       </div>


//     </>
//   )
// }
// export default Redeem






import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Wallet,
  Coins,
  ArrowRightLeft,
  ShieldCheck,
  IndianRupee,
  Sparkles,
} from "lucide-react";
import Header from "../Components/Header";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import { apiRequest } from "../../apiService/allApi";
import css from "../css/Addcase.module.css";

const Redeem = ({ walletUpdate }) => {
  const history = useHistory();

  const [amount, setAmount] = useState("");
  const [userAllData, setUserAllData] = useState(null);
  const [loading, setLoading] = useState(false);

  const role = async () => {
    try {
      socket.emit("getprofile");

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest("me", "GET", null, headers);
      setUserAllData(res.data);
    } catch (error) {
      console.error("Profile fetch failed:", error);
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("token");

    if (!accessToken) {
      history.push("/login");
      return;
    }

    role();
  }, [history]);

  const deposit = async () => {
    const redeemAmount = Number(amount);

    if (!amount || !Number.isFinite(redeemAmount)) {
      Swal.fire({
        title: "Enter Amount",
        text: "Please enter the amount you want to redeem.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#d4af37",
      });
      return;
    }

    if (redeemAmount < 100 || redeemAmount > 10000) {
      Swal.fire({
        title: "Invalid Amount",
        text: "Amount must be between ₹100 and ₹10,000.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#d4af37",
      });
      return;
    }

    try {
      setLoading(true);

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest(
        "referral/to/wallet",
        "POST",
        { amount: redeemAmount },
        headers
      );

      if (res?.data?.msg === "Invalid Amount") {
        Swal.fire({
          title: "Insufficient Balance",
          text: "You don't have sufficient referral balance.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#d4af37",
        });
      } else {
        await Swal.fire({
          title: "Redeem Successful",
          text: "Your referral balance conversion request was successful.",
          icon: "success",
          confirmButtonText: "Great!",
          confirmButtonColor: "#d4af37",
        });

        setAmount("");
        await role();

        if (typeof walletUpdate === "function") {
          walletUpdate();
        }
      }
    } catch (error) {
      Swal.fire({
        title: "Something went wrong",
        text:
          error?.response?.data?.msg ||
          "Unable to redeem right now. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#d4af37",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header user={userAllData} />

      <div className="mk-redeem-page">
        <div className="mk-redeem-container">
          {/* Heading */}
          <div className="mk-redeem-heading">
            <div className="mk-heading-icon">
              <ArrowRightLeft size={22} />
            </div>

            <div>
              <h2>Redeem Balance</h2>
              <p>Convert your referral earnings into MKADDA Coins</p>
            </div>
          </div>

          {/* Main card */}
          <div className="mk-redeem-card">
            <div className="mk-card-top">
              <div>
                <span className="mk-eyebrow">MKADDA REWARDS</span>
                <h3>Referral Wallet</h3>
                <p>Turn your earnings into coins</p>
              </div>

              <div className="mk-wallet-icon">
                <Wallet size={27} />
              </div>
            </div>

            <div className="mk-gold-divider" />

            <div className="mk-redeem-info">
              <div className="mk-info-icon">
                <Coins size={19} />
              </div>

              <div>
                <strong>Convert Referral Balance</strong>
                <p>
                  Your redeemed amount will be credited to your MKADDA Coin
                  wallet.
                </p>
              </div>
            </div>

            {/* Tax notice */}
            <div className="mk-tax-notice">
              <ShieldCheck size={18} />
              <div>
                <strong>TDS Information</strong>
                <p>
                  TDS (0%) will be deducted after earnings of ₹15,000.
                  Please verify the applicable tax rules.
                </p>
              </div>
            </div>

            {/* Amount input */}
            <label className="mk-amount-label" htmlFor="redeem-amount">
              Enter Redeem Amount
            </label>

            <div className="mk-amount-input-wrap">
              <span className="mk-rupee-icon">
                <IndianRupee size={20} />
              </span>

              <input
                id="redeem-amount"
                type="number"
                min="100"
                max="10000"
                step="1"
                value={amount}
                placeholder="Enter amount"
                onChange={(e) => setAmount(e.target.value)}
                onKeyDown={(e) => {
                  if (["-", "+", "e", "E"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />

              <span className="mk-input-currency">INR</span>
            </div>

            <div className="mk-amount-limits">
              <span>Minimum: ₹100</span>
              <span>Maximum: ₹10,000</span>
            </div>

            {/* Quick amounts */}
            <div className="mk-quick-label">Quick Select</div>

            <div className="mk-quick-amounts">
              {[100, 500, 1000, 5000].map((value) => (
                <button
                  type="button"
                  key={value}
                  className={`mk-quick-btn ${
                    Number(amount) === value ? "active" : ""
                  }`}
                  onClick={() => setAmount(String(value))}
                >
                  ₹{value.toLocaleString("en-IN")}
                </button>
              ))}
            </div>

            {/* Redeem button */}
            <button
              type="button"
              className="mk-redeem-button"
              onClick={deposit}
              disabled={loading}
            >
              {loading ? (
                <span className="mk-button-content">
                  <span className="mk-spinner" />
                  Processing...
                </span>
              ) : (
                <span className="mk-button-content">
                  <Sparkles size={18} />
                  Redeem Now
                  <ArrowRightLeft size={18} />
                </span>
              )}
            </button>

            <p className="mk-secure-note">
              <ShieldCheck size={14} />
              Secure wallet transaction
            </p>
          </div>

          <div className="mk-redeem-footer">
            <Coins size={17} />
            <span>Your rewards, converted into coins.</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Redeem;
